import { render, staticRenderFns } from "./footernew.vue?vue&type=template&id=362d25af&scoped=true&"
import script from "./footernew.vue?vue&type=script&lang=js&"
export * from "./footernew.vue?vue&type=script&lang=js&"
import style0 from "./footernew.vue?vue&type=style&index=0&id=362d25af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362d25af",
  null
  
)

export default component.exports